import { render, staticRenderFns } from "./ModalAlertRegister.vue?vue&type=template&id=62017ff4&"
import script from "./ModalAlertRegister.vue?vue&type=script&lang=js&"
export * from "./ModalAlertRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports